module.exports = __webpack_public_path__ + "assets/discount_active-239529.svg";